<script setup lang="ts">
import type { TabTriggerProps } from "./tab.types";
import { useTabTrigger } from "./useTabTrigger";

const props = withDefaults(defineProps<TabTriggerProps>(), {
  color: "neutral",
  variant: "subtle",
  size: "md",
  disabled: false,
});

const {
  isActive,
  isDisabled,
  color,
  activeVariant,
  onClick,
  hasDescription,
  buttonClass,
  contentClass,
  descriptionClass,
} = useTabTrigger({ props });
</script>

<template>
  <e-button
    :id="`tab-trigger-${props.value}`"
    part="base"
    :class="buttonClass"
    class="e-tab-trigger"
    role="tab"
    :aria-selected="isActive ?? false"
    :data-active="isActive"
    :data-has-description="hasDescription ? '' : undefined"
    :color="color"
    :variant="activeVariant"
    :size="props.size"
    :disabled="isDisabled"
    :icon="props.icon"
    @click="onClick"
  >
    <template v-if="props.title || props.description">
      <span :class="contentClass">
        <span v-if="props.title" part="title">{{ props.title }}</span>
        <span v-if="props.description" part="description" :class="descriptionClass">{{ props.description }}</span>
      </span>
    </template>
    <slot />
  </e-button>
</template>
